import React from 'react';
import { Navigation } from '../components/Navigation';
import { TrialOfferCTA } from '../components/TrialOfferCTA';
import { Footer } from '../components/Footer';
import { ClassesHero } from './classes/ClassesHero';
import { ScheduleBanner } from './classes/ScheduleBanner';
import { ProgramsList } from './classes/ProgramsList';
import { ClassesCTA } from './classes/ClassesCTA';
export function ClassesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-362">
      <Navigation data-id="element-363" />
      <ClassesHero data-id="element-364" />
      <ScheduleBanner data-id="element-365" />
      <ProgramsList data-id="element-366" />
      <ClassesCTA data-id="element-367" />
      <TrialOfferCTA data-id="element-368" />
      <Footer data-id="element-369" />
    </div>;
}